var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticStyle: { "margin-top": "1vh" },
          attrs: {
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            width: "800px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
            [_vm._v("客户联系统计")]
          ),
          _c(
            "div",
            { staticClass: "table-container" },
            [
              _c(
                "div",
                { staticClass: "btn-wrap" },
                [
                  _c(
                    "el-tag",
                    {
                      staticClass: "select-stafft-wrap",
                      attrs: {
                        title: "选择员工",
                        closable:
                          _vm.searchMenNames.length === 0 ? false : true,
                        type: "medium",
                        effect: "plain"
                      },
                      on: {
                        close: _vm.searchCloseTag,
                        click: function($event) {
                          return _vm.clickAddMember()
                        }
                      }
                    },
                    [
                      _vm.searchMenNames.length === 0
                        ? _c("span", [_vm._v("选择员工")])
                        : _vm._e(),
                      _vm._l(_vm.searchMenNames, function(item, index) {
                        return _c(
                          "span",
                          { key: index, staticClass: "staff-names" },
                          [
                            _vm._v(_vm._s(item.name)),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.searchMenNames.length > 1 &&
                                      index != _vm.searchMenNames.length - 1,
                                    expression:
                                      "searchMenNames.length>1&&index!=searchMenNames.length-1"
                                  }
                                ]
                              },
                              [_vm._v(",")]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _c("div", { staticClass: "btn-group" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn",
                        class: _vm.params.mark == -1 ? "btn-active" : "",
                        on: {
                          click: function($event) {
                            return _vm.dateChange(-1)
                          }
                        }
                      },
                      [_vm._v("昨日")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "btn",
                        class: _vm.params.mark == 7 ? "btn-active" : "",
                        on: {
                          click: function($event) {
                            return _vm.dateChange(7)
                          }
                        }
                      },
                      [_vm._v("近7日")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "btn",
                        class: _vm.params.mark == 30 ? "btn-active" : "",
                        on: {
                          click: function($event) {
                            return _vm.dateChange(30)
                          }
                        }
                      },
                      [_vm._v("近30日")]
                    )
                  ]),
                  _c("el-date-picker", {
                    staticStyle: { width: "240px" },
                    attrs: {
                      size: "mini",
                      editable: false,
                      type: "daterange",
                      "value-format": "yyyy-MM-dd",
                      "range-separator": "-",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "picker-options": _vm.pickerOptions,
                      clearable: ""
                    },
                    on: { change: _vm.selectTime },
                    model: {
                      value: _vm.searchSelectTime,
                      callback: function($$v) {
                        _vm.searchSelectTime = $$v
                      },
                      expression: "searchSelectTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "table-data" },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      ref: "singleTable",
                      staticStyle: {
                        width: "100%",
                        height: "100%",
                        "font-size": "13px"
                      },
                      attrs: {
                        size: "medium",
                        "header-cell-style": {
                          background: "#eef1f6",
                          color: "#606266"
                        },
                        "highlight-current-row": true,
                        data: _vm.tableData,
                        "default-sort": {
                          prop: "chatCnt",
                          order: "descending"
                        },
                        height: "308px"
                      },
                      on: { "sort-change": _vm.customerSortChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "userName",
                          label: "员工姓名",
                          width: "118",
                          align: "left"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "chatCnt",
                          label: "聊天总数",
                          sortable: "custom",
                          "min-width": "102",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "messageCnt",
                          label: "发送聊天数",
                          sortable: "custom",
                          "min-width": "102",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "avgReplyTime",
                          label: "平均首次回复时长",
                          sortable: "custom",
                          "min-width": "144",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "newApplyCnt",
                          label: "发起申请数",
                          sortable: "custom",
                          "min-width": "102",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "newContactCnt",
                          label: "新增好友数",
                          sortable: "custom",
                          "min-width": "102",
                          align: "center"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-pagination", {
                attrs: {
                  background: true,
                  "current-page": _vm.pageparm.currentPage,
                  "page-size": _vm.pageparm.pageSize,
                  layout: "prev, pager, next, jumper",
                  total: _vm.pageparm.total
                },
                on: {
                  "current-change": _vm.callBack,
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.pageparm, "currentPage", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.pageparm, "currentPage", $event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      ),
      _c("StaffTree", {
        attrs: {
          title: "选择成员",
          dialogVisibleTree: _vm.dialogVisibleTree,
          currentSelectMember: _vm.currentSelectMember
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }